import type { JobHistoryEntryDto } from "@grizzly/shared";
import { jobStatus } from "@grizzly/shared";
import { formatDateTime } from "../../lib/format.js";
import { useI18n, type MessageKey } from "../../i18n/index.js";
import { Badge } from "../ui/badge.js";

export function HistoryPanel({ history }: { history: JobHistoryEntryDto[] }) {
  const { t } = useI18n();
  return (
    <div>
      <h2 className="mb-3 text-sm font-semibold text-ink">{t("jobs.history.title")}</h2>
      {history.length === 0 ? (
        <p className="text-sm text-ink-muted">{t("jobs.history.empty")}</p>
      ) : (
        <ol className="space-y-2">
          {history.map((h) => (
            <li key={h.id} className="text-sm">
              <Badge tone={jobStatus(h.toStatus).tone}>
                {t(`status.job.${h.toStatus}` as MessageKey)}
              </Badge>
              {h.note ? <span className="ms-2 text-ink-muted">— {h.note}</span> : null}
              <span className="ms-2 text-xs text-ink-muted">
                {formatDateTime(h.occurredAt)}
                {h.actorName ? ` · ${h.actorName}` : ""}
              </span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
